/**
 * One multi-select filter section inside a filter drawer/panel — a label
 * plus a list of checkbox rows, where no checked box means no restriction
 * on that axis (OR within the axis; the drawer combines axes with AND).
 * Extracted from TicketsPage's original local helper once JobsFilterDrawer
 * became a second consumer of the exact same shape.
 */
export function FilterCheckboxGroup<T extends string>({
  label,
  value,
  onChange,
  options,
}: {
  label: string;
  value: T[];
  onChange: (value: T[]) => void;
  options: { value: T; label: string }[];
}) {
  const toggle = (option: T) => {
    onChange(
      value.includes(option)
        ? value.filter((v) => v !== option)
        : [...value, option],
    );
  };
  return (
    <div>
      <div className="text-xs font-medium text-muted-foreground uppercase mb-2">
        {label}
      </div>
      <div className="space-y-0.5">
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center gap-2 px-2 py-1.5 rounded-md text-sm cursor-pointer hover:bg-accent/50"
          >
            <input
              type="checkbox"
              checked={value.includes(option.value)}
              onChange={() => toggle(option.value)}
              className="accent-primary"
            />
            {option.label}
          </label>
        ))}
      </div>
    </div>
  );
}
